<script lang="ts">
    import TrashCan from "../assets/trash-can.svg";
    import { deleteSuggestion } from '../actions/deleteSuggestion';

    export let suggestion: string;
    export let id: string;

    const deleteButtonStyle = `background-image: url("${TrashCan}");`;

    function removeSuggestion(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        deleteSuggestion(id);
    }
</script>

<li>
    {suggestion}
    <button class='delete-button' aria-label="delete suggestion" style={deleteButtonStyle} on:click={removeSuggestion}></button>
</li>

<style>
    .delete-button {
        all: unset;
        border: none;
        background-color: transparent;
        background-size: contain;
        background-repeat: no-repeat;
        cursor: pointer;
        height: 1rem;
        width: 1rem;
        vertical-align: middle;
    }
</style>
